// Real Unsplash plant photos — 1:1 square crops
export const plantImages = {
  monstera:       'https://images.unsplash.com/photo-1614594975525-e45190c55d0b?w=600&h=600&fit=crop&auto=format&q=80',
  fiddleleaf:     'https://images.unsplash.com/photo-1586348943529-beaae6c28db9?w=600&h=600&fit=crop&auto=format&q=80',
  pothos:         'https://images.unsplash.com/photo-1591958911259-bee2173bddbf?w=600&h=600&fit=crop&auto=format&q=80',
  peacelily:      'https://images.unsplash.com/photo-1593482892290-f54927ae1bb6?w=600&h=600&fit=crop&auto=format&q=80',
  snakeplant:     'https://images.unsplash.com/photo-1599598425947-5202edd56bdb?w=600&h=600&fit=crop&auto=format&q=80',
  rubberplant:    'https://images.unsplash.com/photo-1545241047-6083a3684587?w=600&h=600&fit=crop&auto=format&q=80',
  zzplant:        'https://images.unsplash.com/photo-1632207691143-643e2a9a9361?w=600&h=600&fit=crop&auto=format&q=80',
  birdofparadise: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&h=600&fit=crop&auto=format&q=80',
  stringofpearls: 'https://images.unsplash.com/photo-1620127682229-33388276e540?w=600&h=600&fit=crop&auto=format&q=80',
  bostonfern:     'https://images.unsplash.com/photo-1572688484438-313a6e50c333?w=600&h=600&fit=crop&auto=format&q=80',
  calathea:       'https://images.unsplash.com/photo-1611048267451-e6ed903b4f69?w=600&h=600&fit=crop&auto=format&q=80',
  aloevera:       'https://images.unsplash.com/photo-1596547609652-9cf5d8c10616?w=600&h=600&fit=crop&auto=format&q=80',
};

export const getPlantImage = (key) =>
  plantImages[key] || 'https://images.unsplash.com/photo-1463320726281-696a3cc57087?w=600&h=600&fit=crop&auto=format&q=80';

// Keep legacy export so nothing else breaks
export const getPlantEmoji = () => '';
export const plantColors = {};
